import React, { createContext, useContext, useMemo } from 'react';
import type { SupportedLanguage } from '../data/supportedLanguages';

type LanguageLandingContextValue = {
  /** Set on /languages/:slug pages; null on the main site */
  language: SupportedLanguage | null;
};

const LanguageLandingContext = createContext<LanguageLandingContextValue>({
  language: null,
});

export const LanguageLandingProvider: React.FC<{
  language: SupportedLanguage | null;
  children: React.ReactNode;
}> = ({ language, children }) => {
  const value = useMemo(() => ({ language }), [language]);
  return (
    <LanguageLandingContext.Provider value={value}>
      {children}
    </LanguageLandingContext.Provider>
  );
};

export function useLanguageLanding(): LanguageLandingContextValue {
  return useContext(LanguageLandingContext);
}

/** Namespace for shared landing sections: home (default EN) vs localized landing */
export function useLandingNamespace(): 'home' | 'landing' {
  const { language } = useLanguageLanding();
  return language ? 'landing' : 'home';
}
